import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const otetsudaiAge2: BlogMetaData = {
  title: '2歳からできるお手伝い一覧｜安全な始め方と声かけ【モンテッソーリ】',
  description:
    '2歳からできるお手伝いを場面別に紹介。安全な環境づくり、見本の見せ方、失敗を許容する声かけ、避けたい任せ方、モンテッソーリの「日常生活の練習」とのつながりまで、今日から始められる形で解説します。',
  thumbnailUrl: '/img/blog-otetsudai-age-2.webp',
  filePath: buildBlogFilePath('otetsudai-age-2'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
